import React, { Component } from "react";
import { Link } from "react-router-dom";

import "./../../public/scss/feedComponent.scss";

import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faCamera, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import ImageUploader from 'react-images-upload';

// import store from './../store';
import PropTypes from 'prop-types';
import { uploadToCloudStorage, createStudentNewFeed } from './../../actions/feedActions';
import { connect } from 'react-redux';
// import { getUserData, logOut } from './../actions/utility';

// Import React FilePond
import { FilePond, registerPlugin } from "react-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import the Image EXIF Orientation and Image Preview plugins
// Note: These need to be installed separately
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    Button,
    Container,
    Row,
    Media,
    Col,
    Card,
    CardTitle,
    CardSubtitle,
    CardBody,
    CardText,
    CardLink,
    Badge,
    Spinner,
    FormGroup,
    Label,
    Input
    // NavLink
} from "reactstrap";

// Register the plugins
registerPlugin(FilePondPluginImagePreview);
registerPlugin(FilePondPluginFileValidateType);

class AddPostComponent extends Component {

  constructor(props) {
    super(props);
    

    this.state = {
        toggleImagesUpload : false,
        studentImage : '',
        studentId : '',
        clientId : '',
        allPrograms : [],
        selectedProgramId : 0,
        imagesData: [],
        imagesDataPrompt: [],
        imagesDataBinary: [],
        // Set initial files, type 'local' means this is a file
        // that has already been uploaded to the server (see docs)
        files: [],
        imagesError: false,
        uploadFeedSuccess : "",
        imagesUploadLoader : false
    };
    // this.onDrop.bind(this);

  }


  componentWillReceiveProps(nextProps, thisProps) {
      
      if(this.props.studentInfo != nextProps.studentInfo) {
        var studentImage = "";
        if(nextProps.studentInfo.image && nextProps.studentInfo.image != null){
            studentImage = "https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/" + nextProps.studentInfo.image;
        }
        this.setState({
            studentImage : studentImage,
            studentId : nextProps.studentInfo.id,
            clientId : nextProps.studentInfo.client_id
        }, () => {
            console.log(this.state.studentImage);
            console.log(this.state.studentId);
            console.log(this.state.clientId);
        })
      }

      //get all programs assigned to this candidate
      if(this.props.programs != nextProps.programs) {
        this.setState({
            allPrograms : nextProps.programs
        }, () => {
            console.log(this.state.allPrograms)
        })
      }

      if(this.props.uploadToStorageResponse != nextProps.uploadToStorageResponse) {
        //   https://lincolnmethod.s3.us-east-1.amazonaws.com/Feeds/

        var imagesDataArray = this.state.imagesData;
        imagesDataArray.push(nextProps.uploadToStorageResponse.data.image_name);
        var imagesDataArrayPrompt = this.state.imagesDataPrompt;
        imagesDataArrayPrompt.push('');
        
        this.setState({
            imagesData: imagesDataArray,
            imagesDataPrompt: imagesDataArrayPrompt
        }, () => {
            if(this.state.imagesDataBinary.length === nextProps.uploadToStorageResponse.count) { // that means all images are successfully uploaded to s3 storage
                this.finalyUploadedImages();
            }
        });

      }

      if(this.props.createNewFeedResponse != nextProps.createNewFeedResponse) {

        if(nextProps.createNewFeedResponse.data.status == "success") { // Feed is uploaded successfully
            this.setState({
                toggleImagesUpload : false,
                files : [],
                uploadFeedSuccess: "Your request for uploading your work on newsfeed is benig sent to our tutors."
            })
        }

        this.setState({
            imagesUploadLoader : false
        })

      }

  }

    finalyUploadedImages = () => {
        
        var feedData = {};
        var feeddatahere = {
            feed_subject : "",
            feed_topic : "",
            feed_performance : "",
            feed_comprehension : "",
            feed_willingness : "",
            feed_images : this.state.imagesData,
            feed_images_desc : this.state.imagesDataPrompt
        };

        feedData['feed_clientid']      = this.state.clientId;
        feedData['feed_teacherid']     = 0;
        feedData['feed_studentid']     = this.state.studentId;
        feedData['feed_prog_id']       = parseInt(this.state.selectedProgramId);
        feedData['feed_asses_id']      = 0;
        feedData['feed_topic_id']      = 0;
        feedData['feed_iscomplete']    = 0;
        feedData['feed_data']          = JSON.stringify(feeddatahere);
        feedData['feed_notifyparent']  = 0;
        feedData['feed_isself']        = 1;

        console.log(feedData);
        
        this.props.createStudentNewFeed(feedData);

    }

    updateImagesBinaryState = (pictures) => {

        var tempArray = [];
        
        pictures.map((pic, key) => {

            var reader = new FileReader();
            reader.onloadend = function () {
                // Since it contains the Data URI, we should remove the prefix and keep only Base64 string
                var b64 = reader.result;
                tempArray.push({
                    id: key,
                    data: b64
                });
            };
            reader.readAsDataURL(pic);

        })
        this.setState({
            imagesDataBinary : tempArray,
            imagesError : false
        }, () => {
            console.log(this.state.imagesDataBinary)
        })

    }

    uploadActivityImages = () => {
        if(this.state.imagesDataBinary.length) {
            this.setState({
                imagesUploadLoader : true
            }, () => {
                this.state.imagesDataBinary.map((image, key) => {
                    console.log(image.data)
                    this.props.uploadToCloudStorage(image.data, key+1); // upload the image to s3 cloud storage
                })
            })
        } else{
            this.setState({
                imagesError : true
            })
        }
    }
  
  componentDidMount() {
      
    var studentImage = "";
    if(this.props.studentInfo.image && this.props.studentInfo.image != null){
        studentImage = "https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/" + this.props.studentInfo.image;
    }
    this.setState({
        studentImage : studentImage,
        studentId : this.props.studentInfo.id,
        clientId : this.props.studentInfo.client_id
    }, () => {
        console.log(this.state.studentImage);
        console.log(this.state.studentId);
        console.log(this.state.clientId);
    })
        
  }

  handleInit() {
    console.log("FilePond instance has initialised", this.pond);
  }

  render() {

    return (
        <Card id="addPostMainContainer" className={ this.state.toggleImagesUpload ? "addPostMainContainer withShadow" : "addPostMainContainer"}>
            <CardBody>
                {
                    this.state.toggleImagesUpload ?
                    
                    <Row style={{textAlign: 'left'}} className="createPostBox">
                        <Col xs={{size: 12}}>
                            
                            <Media className="tutorThumb addphoto" object src={ this.state.studentImage && this.state.studentImage != "" ? this.state.studentImage : "http://info.lincolnmethod.com/wp-content/uploads/2019/12/noimage.png" } alt={ this.state.studentImage } />
                                    
                            <h6 style={{display: 'inline-block', marginLeft: '10px'}}>Upload photos</h6>
                            <FontAwesomeIcon className="iconClose" icon={ faTimesCircle } size="2x" color="#333" onClick={e => {
                                this.setState({
                                    toggleImagesUpload : !this.state.toggleImagesUpload
                                })
                            }} />
                            <hr></hr>
                        </Col>
                        <Col xs={{size: 12}}>
                            <Row style={{textAlign: 'center'}}>
                                {/* {
                                    this.state.imagesDataBinary.length ?
                                        this.state.imagesDataBinary.map((image, key) => 
                                            <Col xs={{size: 3}} key={key}>
                                                <Media width="150" object src={ image.data } />
                                            </Col>
                                        )
                                    : null
                                } */}
                                <Col xs={{size: 12}}>
                                    <FilePond
                                        ref={ref => (this.pond = ref)}
                                        files={this.state.files}
                                        allowMultiple={true}
                                        maxFiles={5}
                                        onwarning={(e) => e.body == "Max files" ? alert("More than 5 images are not allowed") : alert(e.body)}
                                        allowFileTypeValidation={true}
                                        acceptedFileTypes={['image/*']}
                                        labelFileTypeNotAllowed={"file type is not valid, Please upload images only"}
                                        // server="/api"
                                        oninit={() => this.handleInit()}
                                        onupdatefiles={fileItems => {
                                            // Set currently active file objects to this.state
                                            this.setState({
                                                files: fileItems.map(fileItem => fileItem.file)
                                            }, () => {
                                                // console.log(this.state.files);
                                                this.updateImagesBinaryState(this.state.files);
                                            });
                                        }}
                                    />
                                    {
                                        this.state.imagesError ?
                                            <p style={{color: 'red', fontSize: '12px', position: 'relative', left: '10px', top: '-8px', textAlign: 'left'}}>There's no image selected</p>
                                        : null
                                    }
                                </Col>
                            </Row>
                            
                            <Row>
                                <Col xs={{size: 12}}>
                                    <FormGroup style={{display: 'inline-block', width: '100%'}}>
                                        {/* <Label for="selectProgram" style={{fontSize: '12px'}}>Select program</Label> */}
                                        <Input type="select" name="selectProgram" id="selectProgram" onChange={(evt) => {
                                            this.setState({ selectedProgramId: evt.target.value });
                                        }}>
                                            <option defaultValue>Select program</option>
                                            {
                                                this.props.programs.map((program, key) => 
                                                    <option key={key} value={program.progid}>{program.coursename ? program.coursename : program.prog_name}</option>
                                                )
                                            }
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col style={{textAlign: 'right'}}>
                                    <Button color="warning" onClick={e => this.uploadActivityImages()}>
                                        {
                                            this.state.imagesUploadLoader ?
                                                <Spinner style={{marginRight: '10px', position: 'relative', top: '-3px'}} color="dark" size="sm" />
                                            : null
                                        }
                                        Upload
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    :
                    
                    <Row style={{textAlign: 'left', cursor: 'pointer'}} onClick={e => {
                        this.setState({
                            toggleImagesUpload : !this.state.toggleImagesUpload
                        })
                    }}>
                        <Col xs={{size: 8}}>
                            <h5>Upload photos of your work so our tutors can check it and show you video solutions</h5>
                            {
                                this.state.uploadFeedSuccess != "" ?
                                    <p style={{fontSize: '14px', margin: 0, color: 'green'}}>
                                        {
                                            this.state.uploadFeedSuccess
                                        }
                                    </p>
                                : null
                            }
                        </Col>
                        <Col xs={{size: 4}} style={{ textAlign: 'center' }}>
                            <FontAwesomeIcon icon={ faCamera } size="4x" color="#fff" /><br/>
                            <Button color="warning" size="sm">Upload</Button>
                        </Col>
                    </Row>
                }
                
            </CardBody>
        </Card>
    )

  }
}

AddPostComponent.propTypes = {
    uploadToCloudStorage: PropTypes.func.isRequired,
    createStudentNewFeed: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    uploadToStorageResponse: state.feedRed.uploadToStorageResponse,
    createNewFeedResponse: state.feedRed.createNewFeedResponse
})

export default connect(mapStateToProps, { uploadToCloudStorage, createStudentNewFeed })(AddPostComponent);
